<template>
    <el-dialog
            title="修改密码"
            :visible.sync="visible"
            :append-to-body="true"
            width="500px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px">
            <el-form-item label="账号">
                <span>{{ userName }}</span>
            </el-form-item>
            <el-form-item label="原密码" prop="password">
                <el-input type="password" v-model="dataForm.password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input type="password" v-model="dataForm.newPassword"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
                <el-input type="password" v-model="dataForm.confirmPassword"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            var validateConfirmPassword = (rule, value, callback) => {
                if (this.dataForm.newPassword !== value) {
                    callback(new Error('确认密码与新密码不一致'))
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                dataForm: {
                    password: '',
                    newPassword: '',
                    confirmPassword: ''
                },
                dataRule: {
                    password: [
                        {required: true, message: '原密码不能为空', trigger: 'blur'}
                    ],
                    newPassword: [
                        {required: true, message: '新密码不能为空', trigger: 'blur'}
                    ],
                    confirmPassword: [
                        {required: true, message: '确认密码不能为空', trigger: 'blur'},
                        {validator: validateConfirmPassword, trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            userName: {
                get() {
                    return JSON.parse(localStorage.user).username
                }
            }
        },
        methods: {
            // 初始化
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: '/sys/user/password',
                            method: 'post',
                            data: {
                                'id': JSON.parse(localStorage.user).id,
                                'password': this.dataForm.password,
                                'newPassword': this.dataForm.newPassword
                            }
                        }).then(resp => {
                            if (resp.data && resp.data.code === 0) {
                                this.$message({
                                    message: '密码修改成功，请重新登录！',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            localStorage.removeItem('user');
                                            this.$router.push('/login');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(resp.data.msg)
                            }
                        })
                    }
                })
            }
        }
    }
</script>
